import { ILiveblogWidgetsConfig } from '@sky-it-cmscomposer/liveblog-widgets';

interface IEndpointConfig extends ILiveblogWidgetsConfig {
  apikey: string;
}

export function isValidConfigurationObject(o: any): o is IEndpointConfig {
  return 'apikey' in o && 'endpoint' in o;
}

// @ts-ignore
export const getServiceConfiguration = (): IEndpointConfig => {
  const configurationObject: IEndpointConfig =
    // @ts-ignore
    window?.SkyFoundationSettings?.EDITORIAL_LIVEBLOG;
  if (isValidConfigurationObject(configurationObject)) {
    return configurationObject;
  } else {
    throw new Error(`invalid configuration object', ${configurationObject}`);
  }
};
